module.exports = __webpack_public_path__ + "static/media/welcome.387a5d4f.jpg";